import React from "react";

const EmailList = () => {
  return <div>Email List</div>;
};

export default EmailList;
